<template>
	<teleport to="#modal">
		<div class="modal_container">
			<div ref="modalEl" class="modal_box">
				<!-- 모달 헤더 들어가는 부분 -->
				<div v-if="title || isClose" class="modal_header">
					<h3 v-if="title" class="modal_title">{{ title }}</h3>
					<button v-if="isClose" class="btn_close" @click="onClickClose">
						<CloseIcon />
					</button>
				</div>
				<!-- 모달 콘텐츠 들어가는 부분 -->
				<div class="modal_content">
					<slot></slot>
				</div>
			</div>
		</div>
	</teleport>
</template>

<script setup lang="ts">
// core
import { onUnmounted, ref } from 'vue';
// vueuse
import { onClickOutside } from '@vueuse/core';

// svg
import CloseIcon from '@/assets/img/common/clear.svg?component';
// store
import { ModalType, useModalStore } from '@/stores/modal';

// -----variable-----
const props = defineProps<{
	modalName: ModalType;
	title?: string;
	isClose?: boolean;
}>();

const modalStore = useModalStore();
const modalEl = ref();

const onClickClose = () => {
	modalStore.closeModal(props.modalName);
};
//모달 외부 클릭시 모달 닫기
onClickOutside(modalEl, () => {
	modalStore.closeModal(props.modalName);
});
onUnmounted(() => {
	document.body.classList.remove('hidden');
});
</script>

<style scoped lang="scss">
.modal_container {
	z-index: 999;
	position: fixed;
	top: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background: #00000070;

	.modal_box {
		position: relative;
		width: fit-content;
		border-radius: 1rem;
		background-color: var(--color-bg-mid);
		padding: 0 2rem 2rem;
		@media screen and (max-width: 768px) {
			max-width: calc(100% - 4rem);
		}
		// @media screen and (max-width: 360px) {
		// 	max-width: 100%;
		// }
		.modal_header {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			padding: 3.2rem 0 4rem;
			.modal_title {
				flex-grow: 1;
				font-size: var(--font-s-x-large);
				font-weight: var(--font-w-semi-bold);
				color: var(--color-base-white);
			}
			.btn_close {
				z-index: 100;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-grow: 0;
				width: var(--font-size-xx-large);
				height: var(--font-size-xx-large);
				padding: 0;
				border: none;
				cursor: pointer;
			}
		}
		.modal_content {
			max-height: 70vh;
			overflow: hidden;
			overflow-y: auto;
			padding: 1px 2rem; /* 위아래 1px 안하면 크롬 버그로 overflow됨, 양옆은 스크롤바 끝으로 옮기려고 설정 */
			margin: 0 calc(2rem * -1);
			&::-webkit-scrollbar {
				-webkit-appearance: none;
				width: 4px;
			}

			&::-webkit-scrollbar-track {
				background: transparent;
			}
			&::-webkit-scrollbar-thumb {
				border-radius: 100px;
				background-color: #ccc;
			}
		}
	}
}

.modal_container .modal_box .modal_header {
	padding: 2.4rem 0 2rem;
}
.modal_container .modal_box {
	padding: 0 2rem;
}
.modal_container .modal_box .modal_content {
	padding: 0 1.6rem 2rem 1.6rem;
}
</style>
